import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import useThemeContext from "../../hooks/useThemeSwitch";
import { setRootContainerWidth } from "../../reducers/layout/layoutReducer";
import ReportQueueManagement from "../../components/ReportQueueManagement/ReportQueueManagement";
import { Dialog, DialogContent } from "@material-ui/core";

const ReportQueuePage = (props) => {
  const { layoutReducer } = useThemeContext();
  const [, layoutDispatch] = layoutReducer;
  const location = useLocation();
  const [dialogOpen, setDialogOpen] = useState(false);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const poppedOut = queryParams.get("poppedOut")?.toLowerCase() === "true";

    if (poppedOut) {
      setDialogOpen(true);
    } else {
      layoutDispatch({ type: setRootContainerWidth, payload: false });
    }
  }, [location.search, layoutDispatch]);

  return (
    <>
      {dialogOpen ? (
        <Dialog fullScreen open={dialogOpen}>
          <DialogContent>
            <ReportQueueManagement />
          </DialogContent>
        </Dialog>
      ) : (
        <ReportQueueManagement />
      )}
    </>
  );
};

export default ReportQueuePage;
